// interpolate=true ensure that the returned geometry will match the curvature of the road -- smoothly follows the geometry of the road, even around corners and through tunnels
// With interpolate=false, the snapped path will still follow the road, but the resulting polyline will not be as smooth.
const INTERPOLATE_ROAD = true

export async function getSnapToRoad(pathToBeSnapped) {
  let snappedPoints = []
  if (pathToBeSnapped) {
    const response = await fetch(`https://roads.googleapis.com/v1/snapToRoads?path=${pathToBeSnapped}&key=${process.env.VUE_APP_GMAPS_KEY}&interpolate=${INTERPOLATE_ROAD}`)
    if (response.ok) {
      const resJson = await response.json()
      if (Array.isArray(resJson.snappedPoints) && resJson.snappedPoints.length > 0) {
        snappedPoints = resJson.snappedPoints
      }
    }
  }
  return snappedPoints
}
